<form [formGroup]="operationalToolsForm" class="operational-tools-form">
  <div class="form-section">
    <div class="tools-section">
      <fieldset>
        <legend class="section-label">
          Are you looking for anything on this list?
        </legend>

        <!-- Business Banking -->
        <div class="tool-category">
          <h4 class="category-title">Business Banking</h4>
          <div class="checkbox-grid" formGroupName="businessBanking">
            @for (option of businessBankingOptions; track option) {
              <div class="checkbox-item">
                <input
                  [id]="'banking_' + sanitizeKey(option)"
                  type="checkbox"
                  [formControlName]="sanitizeKey(option)"
                />
                <label [for]="'banking_' + sanitizeKey(option)">{{
                  option
                }}</label>
              </div>
            }
          </div>
        </div>

        <!-- Marketing Help -->
        <div class="tool-category">
          <h4 class="category-title">Marketing Help</h4>
          <div class="checkbox-grid" formGroupName="marketingHelp">
            @for (option of marketingHelpOptions; track option) {
              <div class="checkbox-item">
                <input
                  [id]="'marketing_' + sanitizeKey(option)"
                  type="checkbox"
                  [formControlName]="sanitizeKey(option)"
                />
                <label [for]="'marketing_' + sanitizeKey(option)">{{
                  option
                }}</label>
              </div>
            }
          </div>
        </div>

        <!-- Tech Support -->
        <div class="tool-category">
          <h4 class="category-title">Tech Support</h4>
          <div class="checkbox-grid" formGroupName="techSupport">
            @for (option of techSupportOptions; track option) {
              <div class="checkbox-item">
                <input
                  [id]="'tech_' + sanitizeKey(option)"
                  type="checkbox"
                  [formControlName]="sanitizeKey(option)"
                />
                <label [for]="'tech_' + sanitizeKey(option)">{{
                  option
                }}</label>
              </div>
            }
          </div>
        </div>

        <!-- Business Insurance -->
        <div class="tool-category">
          <h4 class="category-title">Business Insurance</h4>
          <div class="checkbox-grid" formGroupName="businessInsurance">
            @for (option of businessInsuranceOptions; track option) {
              <div class="checkbox-item">
                <input
                  [id]="'insurance_' + sanitizeKey(option)"
                  type="checkbox"
                  [formControlName]="sanitizeKey(option)"
                />
                <label [for]="'insurance_' + sanitizeKey(option)">{{
                  option
                }}</label>
              </div>
            }
          </div>
        </div>

        <!-- New Technology Tools -->
        <div class="tool-category">
          <h4 class="category-title">New Technology Tools</h4>
          <div class="checkbox-grid" formGroupName="newTechnology">
            @for (option of newTechnologyOptions; track option) {
              <div class="checkbox-item">
                <input
                  [id]="'newtech_' + sanitizeKey(option)"
                  type="checkbox"
                  [formControlName]="sanitizeKey(option)"
                />
                <label [for]="'newtech_' + sanitizeKey(option)">{{
                  option
                }}</label>
              </div>
            }
          </div>
        </div>
      </fieldset>
    </div>
  </div>
</form>
